import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StyleRules } from '@material-ui/styles/withStyles';
import { COLORS } from 'src/styles/colors';

export const useStyles = makeStyles(
  (): StyleRules =>
    createStyles({
      root: {
        alignItems: 'center',
      },
      text: {
        marginRight: '2rem',
        color: COLORS.black,
      },
    })
);
